import { useMutation } from '@tanstack/react-query'
import { Request } from 'commons/utils/request/request'
import { Toast } from 'ui/components/Toast'

import { handlerServerError } from '@orbit/errors'

export const useDeleteFile = (mrId: number, invalidateMR?: () => Promise<void>) => {
  const { mutate: deleteFile, isPending } = useMutation<void, Error, { id: number }>({
    mutationFn: (opts) => Request.delete(Request.urls.bank.reportFile, { id: opts.id }),
    onSuccess: () => {
      Toast.successSmall('File was deleted.')
      if (mrId && invalidateMR) invalidateMR()
    },
    onError: (error) => handlerServerError(error)
  })

  return {
    deleteFile,
    isPending
  }
}
